/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxAsadoGriddgleComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxAsadoGriddgle').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'GRIDDLE_LYNX_ASADO_L30AG',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-asado-griddgle.js.map